define( [
	"../Data"
], function( Data ) {
	return new Data();
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/data/var/dataPriv.js
// module id = 837
// module chunks = 2